module.exports = __webpack_public_path__ + "e838ddacd55fb2ff2fab8b3442eb2e6c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/grachio-data-collect.png
// module id = 259
// module chunks = 1